(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["digital-purchase"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('digital-purchase')){
    customElements.define('digital-purchase',class extends HTMLElement{
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        this.form=this.querySelector('[data-purchase-form]');
        this.design=this.querySelector('[data-product-choice]');
        this.variant=this.querySelector('[data-variant-choice]');
        this.customization=this.querySelector('[data-customization]');
        this.price=this.querySelector('[data-purchase-price]');
        this.buttons=Array.from(this.querySelectorAll('[data-purchase-submit]'));
        this.status=this.querySelector('[data-cart-status]');
        this.error=this.querySelector('[data-purchase-error]');
        this.buttonTexts=this.buttons.map(button=>button.textContent);
        this.design.addEventListener('change',()=>this.loadVariants());
        this.variant.addEventListener('change',()=>this.updateVariant());
        this.form.addEventListener('submit',event=>this.checkout(event));
        this.loadVariants();
      }
      loadVariants(){
        const template=Array.from(this.querySelectorAll('template[data-product-variants]')).find(item=>item.dataset.productVariants===this.design.value);
        this.variant.replaceChildren();
        if(template){this.variant.append(template.content.cloneNode(true));this.variant.disabled=false;}
        else{this.variant.add(new Option(this.dataset.choose,''));this.variant.disabled=true;}
        const requested=new URLSearchParams(window.location.search).get('variant');
        if(requested&&Array.from(this.variant.options).some(option=>option.value===requested&&!option.disabled))this.variant.value=requested;
        this.updateVariant();
      }
      updateVariant(){
        const option=this.variant.selectedOptions[0];
        const customized=option?.dataset.custom==='true';
        this.customization.hidden=!customized;
        this.customization.disabled=!customized;
        this.price.textContent=option?.dataset.price||'—';
        this.buttons.forEach(button=>{button.disabled=!option?.value||option.disabled||this.variant.disabled||!!this.pending;});
        this.error.hidden=true;
      }
      selectDesign(title){
        const option=Array.from(this.design.options||[]).find(item=>item.dataset.designTitle===title);
        if(option&&!option.disabled){this.design.value=option.value;this.loadVariants();}
      }
      async checkout(event){
        event.preventDefault();
        if(this.pending||!this.form.reportValidity()||this.buttons[0].disabled)return;
        const checkout=event.submitter?.dataset.action==='checkout';
        this.pending=true;this.buttons.forEach(button=>{button.disabled=true;});
        if(event.submitter)event.submitter.textContent=this.dataset.busy;
        this.error.hidden=true;this.status.hidden=true;
        try{
          const data=new FormData(this.form);
          data.set('sections','cart-icon-bubble');
          data.set('sections_url',window.location.pathname);
          const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{Accept:'application/json'},body:data});
          const result=await response.json();
          if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);
          if(checkout){this.querySelector('[data-checkout-redirect]').submit();return;}
          const icon=document.getElementById('cart-icon-bubble');
          const markup=result.sections?.['cart-icon-bubble'];
          if(icon&&markup){
            const documentFragment=new DOMParser().parseFromString(markup,'text/html');
            const content=documentFragment.querySelector('.shopify-section');
            if(content)icon.innerHTML=content.innerHTML;
          }
          this.status.textContent=this.dataset.added;this.status.hidden=false;
          this.pending=false;this.buttons.forEach((button,index)=>{button.textContent=this.buttonTexts[index];});this.updateVariant();
        }catch(error){
          this.error.textContent=error.message||this.dataset.error;this.error.hidden=false;
          this.pending=false;this.buttons.forEach((button,index)=>{button.textContent=this.buttonTexts[index];});this.updateVariant();this.error.hidden=false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
